import { Typography } from "@povio/ui";
import Link from "next/link";

import { BoneIcon } from "@/assets/icons/ui/Bone";
import { DemoClickWrapper } from "@/components/shared/demo/DemoClickWrapper";
import { RouteConfig } from "@/config/route.config";
import { LoyaltyQueries } from "@/data/loyalty/loyalty.queries";
import { NumberUtils } from "@/util/number.utils";

export const TreatsButton = () => {
  const { data: pointsData, isLoading: pointsLoading } = LoyaltyQueries.useGetPoints();

  const isLoading = pointsLoading;

  if (isLoading) {
    return null;
  }

  return (
    <DemoClickWrapper>
      <Link
        href={RouteConfig.MyRewards}
        className="flex h-5 cursor-pointer items-center justify-center gap-0-5 rounded-s border border-interactive-contained-primary-pressed bg-interactive-contained-primary-idle py-0-5 pr-1-5 pl-1"
      >
        <BoneIcon className="size-4 text-interactive-contained-primary-on-idle" />
        <Typography
          size="label-4"
          variant="prominent-1"
          className="text-interactive-contained-primary-on-idle leading-none"
        >
          {NumberUtils.formatNumberToShort(pointsData?.currentBalance ?? 0)}
        </Typography>
      </Link>
    </DemoClickWrapper>
  );
};
